export const fmtISO = (d) => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const fromISO = (iso) => {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
};

export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};

export const fmtLong = (d) =>
  d.toLocaleDateString('en-PH', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });

export const fmtDow = (d) =>
  d.toLocaleDateString('en-PH', { weekday: 'short' }).toUpperCase().slice(0, 3);

export const fmtDay = (d) => d.getDate().toString();

export const isSameDay = (a, b) => fmtISO(a) === fmtISO(b);

export const fmtHM = (mins) => {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
};

// v2.0 — 15-minute granularity helpers.
// Entry minutes are constrained to {0, 15, 30, 45}. The hours field stays a
// free integer 0–8 so users can still log up to 8h per entry. These helpers
// live alongside fmtHM because every consumer of "minutes" needs them.
export const MINUTE_OPTIONS = [0, 15, 30, 45];

// Round up to the next 15-min boundary — used when importing a calendar
// event so a 23-min meeting lands at 30m. Exact quarters stay put.
export const roundUpTo15 = (mins) => {
  const v = Math.max(0, parseInt(mins, 10) || 0);
  return Math.ceil(v / 15) * 15;
};

// Round to the nearest 15-min boundary — used when a legacy entry (created
// before v2.0 enforced the granularity) is opened for edit. We snap so the
// segmented control has a value to highlight; the user can adjust before
// saving. 0–7 → 0, 8–22 → 15, etc.
export const snapTo15 = (mins) => {
  const v = Math.max(0, parseInt(mins, 10) || 0);
  return Math.round(v / 15) * 15;
};

export const isQuarterHour = (mins) =>
  MINUTE_OPTIONS.includes(parseInt(mins, 10));
